import $ from 'jquery';

export function onImgLoad(selector, callback) {
  $(selector).each(function() {
    if ( this.complete || /*for IE 10-*/ ($(this).height() > 0 && $(this).naturalWidth > 0) ) {
      callback.apply(this);
    } else {
      $(this).on('load', function() {
        callback.apply(this);
      });
    }
  });
}
